import React from "react";
import { Grid, Typography } from "@mui/material";
import BookingTypeListTemplate from "./bookingTypeListTemplate";  
import { getCategoryName } from "../../../../../platform/util/utils";

const BusinessBookingTypeList = ({
  business,
  primaryColor= null,
  embeded = false,
  url = null,
}) => {
  const getBookingPath = (bookingType) => {
    return `/${business?.url ?? url}/${bookingType.link}`; // Dynamic path
  };

  const allBookingTypes =
    business?.businessBookingTypes ?? business?.businessBasic?.businessBookingTypes ?? [];

  // Once the business is allowed onto the Booking marketplace, show the
  // company's public booking types without requiring a second visibility flag
  // on each individual type.
  const publicBookingTypes = allBookingTypes.filter(
    (bookingType) => bookingType?.isPublic
  );

  // Group booking types by available category ids, with a stable fallback.
  const categories = [
    ...new Set(publicBookingTypes.map((type) => Number(type?.bookingTypeCategoryId)).filter(Boolean)),
  ];
  const categoryIds = categories.length ? categories : [1, 2, 3];

  if (!publicBookingTypes.length) {
    return (
      <Grid item xs={12}>
        <Typography color="text.secondary">
          No public booking types available yet.
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      {categoryIds.map((categoryId) => {
        const filteredBookingTypes = publicBookingTypes.filter(
          (type) => Number(type?.bookingTypeCategoryId) === Number(categoryId)
        );

        if (filteredBookingTypes.length > 0) {
          const categoryName = getCategoryName(categoryId) 

          return (
            <Grid item xs={12} key={categoryId}>
              <Typography>{categoryName}</Typography>
              <BookingTypeListTemplate
                bookingTypes={filteredBookingTypes}
                category={categoryId}
                primaryColor={primaryColor}
                embeded={embeded}
                ignoreDisplayOnBookingPageflag={true}
                getBookingPath={getBookingPath} // Pass the function as the prop
              />
            </Grid>
          );
        }

        return null;
      })}
    </Grid>
  );
};

export default BusinessBookingTypeList;
